// ─── Détection des virements entre SES PROPRES comptes (module PUR) ──
// Un virement interne apparaît DEUX fois sur les relevés : au débit du compte
// source, au crédit du compte destination. Sans traitement, il gonfle à la fois
// les dépenses et les revenus alors qu'aucun argent n'est entré ni sorti.
//
// Règle : rien n'est appliqué automatiquement (décision de Cédric, 06/08). On
// PROPOSE des paires, l'utilisateur confirme — un faux positif exclurait de
// vraies dépenses des totaux sans qu'il le voie.

const cent = (m) => Math.round(Math.abs(Number(m) || 0) * 100);
const dateDe = (op) => op?.dateBanque || op?.datePaiement || op?.date || '';

// Écart en jours entre deux dates 'AAAA-MM-JJ' (un virement interne met
// rarement plus de quelques jours à apparaître des deux côtés).
function joursEntre(a, b) {
  const [ya, ma, ja] = String(a).split('-').map(Number);
  const [yb, mb, jb] = String(b).split('-').map(Number);
  if (!ya || !yb) return 999;
  return Math.abs(Date.UTC(ya, ma - 1, ja) - Date.UTC(yb, mb - 1, jb)) / 86400000;
}

// Paires candidates : même montant, sens opposés, COMPTES DIFFÉRENTS, dates
// proches. Chaque opération n'est proposée qu'une fois (appariement glouton).
//   operations : actuals ayant un compteId ; toleranceJours : fenêtre de temps.
export function detecterTransferts(operations = [], { toleranceJours = 4 } = {}) {
  const utilisables = operations.filter(op => op && op.compteId && !op.exclu && op.paye !== false && dateDe(op));
  const debits = utilisables.filter(op => op.sens !== 'revenu');
  const credits = utilisables.filter(op => op.sens === 'revenu');

  const prises = new Set();
  const paires = [];
  for (const d of debits) {
    if (prises.has(d.id)) continue;
    // Le meilleur candidat = même montant, autre compte, le plus proche en date.
    const c = credits
      .filter(x => !prises.has(x.id)
        && x.compteId !== d.compteId
        && cent(x.montant) === cent(d.montant)
        && joursEntre(dateDe(x), dateDe(d)) <= toleranceJours)
      .sort((a, b) => joursEntre(dateDe(a), dateDe(d)) - joursEntre(dateDe(b), dateDe(d)))[0];
    if (!c) continue;
    prises.add(d.id); prises.add(c.id);
    paires.push({
      cle: `${d.id}|${c.id}`,
      depuis: d, vers: c,
      montant: Math.abs(Number(d.montant) || 0),
      jours: joursEntre(dateDe(d), dateDe(c)),
    });
  }
  return paires;
}

// Une paire déjà traitée (les deux côtés hors calcul) n'a plus à être proposée.
export const paireTraitee = (p) => !!(p?.depuis?.exclu && p?.vers?.exclu);
